module.exports = __webpack_public_path__ + "static/service_master.5bf14dd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commercial_logos/service_master.png
// module id = 2173
// module chunks = 61762850755587